<div class="container mt-5 mb-5">
  <div class="card border-0">
    <!-- Contenedor principal para el diseño responsivo -->
    <div class="d-flex flex-column flex-lg-row g-0" *ngIf="product">

      <!-- Sección de Imágenes (Columna izquierda en escritorio, arriba en móvil) -->
      <div class="col-12 col-lg-6 border-end order-lg-1">
        <!-- Contenedor con columnas para miniaturas e imagen principal -->
        <div class="row g-0">
          <!-- Columna para las miniaturas, ocupando un 20% del espacio en escritorio -->
          <div class="col-2">
            <div class="gallery-list d-flex flex-column">
              <div *ngFor="let album of albums; let i = index"
                   class="gallery-item"
                   (mouseenter)="hoverImage(true)"
                   (mouseleave)="hoverImage(false)"
                   (click)="selectImage(i)"
                   [class.selected]="selectedImage?.src === album.thumb">
                <img [src]="album.thumb" (mouseenter)="selectImage(i)" class="img-thumbnail" />
                <p>{{ album.caption }}</p>
              </div>
            </div>
          </div>
          <!-- Columna para la imagen principal, ocupando el 80% restante en escritorio -->
          <div class="col-10">
            <div *ngIf="selectedImage" class="selected-image">
              <img [src]="selectedImage?.src" class="img-large" />
              <p>{{ selectedImage?.caption }}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Sección de Detalles del Producto (Columna central en escritorio, segunda en móvil) -->
      <div class="col-12 col-lg-4 order-lg-2">
        <div class="p-3 right-side">
          <div class="d-flex justify-content-between align-items-center">
            <h1>{{ product.product }}</h1>
            <span class="heart">
              <i class='bx bx-heart'></i>
            </span>
          </div>
          <h4>Modelo: {{ product.model |titlecase }}</h4>
          <div class="mt-2 pr-3 content">
            <h4>Marca: {{ product.brand |titlecase }}</h4>
            <div class="ratings d-flex flex-row align-items-center">
              <div class="d-flex flex-row">
                <bar-rating [(rate)]="product.qualification" [max]="5" [readonly]="true"></bar-rating>
                <span>({{product.qualification | number: '1.1-1'}})</span>
              </div>
            </div>

            <br>
            <div *ngIf="!selectedSize" class="price-display">
              <h3 class="dorado">Precio:  {{ product.minPrice |currency }}  - {{ product.maxPrice |currency }} </h3>
            </div>
            <div *ngIf="selectedSize" class="price-display">
              <h3 class="dorado">Precio: {{ selectedSize.price | currency }}</h3>
            </div>
            <p *ngIf="!selectedColor">Selecciona el color:</p>
            <p *ngIf="selectedColor">
              Color: {{ selectedColor.name }}
            </p>
            <div class="color-selector">
              <div *ngFor="let color of colors"
                   class="color-box"
                   [style.backgroundColor]="color.hex"
                   [class.selected]="color === selectedColor"
                   (click)="selectColor(color)">
              </div>
            </div>

            <h3>Selecciona tu talla:</h3>
            <div class="size-options">
              <div class="row">
                <div *ngFor="let size of sizePriceLts; let i = index"
                     (click)="selectSize(size)"
                     [class.selected]="size === selectedSize"
                     class="col-3 size-box">
                  {{ size.size }}
                </div>
              </div>
            </div>

            <br>
            <div *ngIf="product.personalized" class="additional-info">
              <h3>Detalles adicionales para el personalizado:</h3>
              <div class="form-group">
                <label>Nombre de la persona</label>
                <input matInput class="form-control styled-input" [(ngModel)]="newSize.namePerson" placeholder="Nombre de la persona" />
              </div>
              <div class="form-group">
                <label>Cargo</label>
                <input matInput class="form-control styled-input" [(ngModel)]="newSize.position" placeholder="Puesto" />
              </div>
              <div class="form-group">
                <label>Tipo de sangre</label>
                <input matInput class="form-control styled-input" [(ngModel)]="newSize.bloodType" placeholder="Tipo de sangre" />
              </div>
              <div class="form-group">
                <label>Clase</label>
                <input matInput class="form-control styled-input" [(ngModel)]="newSize.claseInProgress" placeholder="Clase" />
              </div>
              <div class="form-group">
                <label>Nombre del club</label>
                <input matInput class="form-control styled-input" [(ngModel)]="newSize.club" placeholder="Nombre del club" />
              </div>
              <div class="form-group">
                <label>Años de servicio</label>
                <input matInput class="form-control styled-input" [(ngModel)]="newSize.yearsService" placeholder="Años de servicio" />
              </div>
            </div>

            <br>
            <br>
            <div class="measurement-table">
              <span class="toggle-text" (click)="openLightbox(lightbox)">
                <u style="color: #e94107;">Tabla de medidas</u>
                <i class="fas fa-chevron-down"></i>
              </span>
            </div>
            <ng-template #lightbox>
              <div class="lightbox-content">
                <img [src]="urlSize" alt="Tabla de medidas" />
              </div>
            </ng-template>

            <br>
            Cantidad:
            <div class="product-quantity">
              <div class="quantity-input">
                <button type="button" class="btn-quantity" (click)="decreaseQuantity()">-</button>
                <input type="number" id="quantity" [(ngModel)]="productQuantity" min="1" max="10000000000000" />
                <button type="button" class="btn-quantity" (click)="increaseQuantity()">+</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Sección de la Caja de Compra (Columna derecha en escritorio, tercera en móvil) -->
      <div class="col-12 col-lg-2 order-lg-3">
        <div class="product-info">
          <div>
            <button type="button" class="btn btn-danger" (click)="regresar()" style="background-color: #ff4d4d; color: white; border: none; cursor: pointer; transition: background-color 0.3s ease;">
              Regresar
            </button>
          </div>
          <div *ngIf="!selectedSize" class="price-display">
            <h4 class="black"> Para comprar, selecciona <strong>Talla</strong> </h4>
          </div>
          <div *ngIf="!selectedSize" class="price-display">
            <h4 class="black"><strong>Precio:  {{ product.minPrice |currency }}  - {{ product.maxPrice |currency }}</strong></h4>
          </div>
          <div *ngIf="selectedSize" class="price-display">
            <h4 class="black"><strong>Precio: {{ selectedSize.price | currency }}</strong></h4>
          </div>
          <p class="shipping-highlight">¡Envío gratis en compras a partir de $2999!</p>
          <p>Fecha estimada de entrega:
            <strong>
              entre {{ createAtPlus5BusinessDays ? translateMonth(createAtPlus5BusinessDays) : 'fecha no disponible' }} y
              {{ createAtPlus20BusinessDays ? translateMonth(createAtPlus20BusinessDays) : 'fecha no disponible' }},
              Realizando el pedido el día de hoy.
            </strong>
          </p>
          <p><strong>Disponible</strong></p>
          <div class="error-messages">
            <div *ngIf="showProductError" class="alert alert-danger">
              No hay producto seleccionado
            </div>
            <div *ngIf="showSizeError" class="alert alert-danger">
              Por favor, selecciona una talla
            </div>
          </div>
          <button class="btn btn-primary" (click)='addCart()'>Agregar al Carrito</button>
          <button class="btn btn-secondary" (click)='goToCar()'>Ir al carrito</button>
          <div class="shipping-info">
            <p><strong>Envío desde:</strong> Camben México</p>
            <p><strong>Vendido por:</strong> Camben México</p>
          </div>
        </div>
      </div>

    </div>

    <!-- Sección de detalles del producto (ancho completo) -->
    <div class="row mt-4" *ngIf="product">
      <div class="col-12">
        <div class="card p-4 shadow-sm">
          <h3 class="mb-3">Detalle del producto</h3>
          <div [innerHTML]="product.detailProduct"></div>
          <hr class="my-4">
          <h3 class="mb-3">Descripción y especificación:</h3>
          <div [innerHTML]="product.description"></div>
        </div>
      </div>
    </div>

    <!-- Sección de Comentarios (ancho completo) -->
    <div class="row mt-4">
      <div class="col-12">
        <h3>Comentarios de Clientes</h3>
        <hr>
        <div *ngIf="productComments && productComments.length > 0; else noComments">
          <div class="comment-section">
            <div *ngFor="let comment of productComments" class="comment-card">
              <div class="d-flex align-items-center mb-2">
                <h5 class="font-weight-bold mb-0 me-2">{{ comment.customerName }}</h5>
                <div class="star-rating">
                  <i class="fas fa-star text-warning" *ngFor="let star of [].constructor(comment.rating)"></i>
                  <i class="far fa-star text-secondary" *ngFor="let star of [].constructor(5 - comment.rating)"></i>
                </div>
              </div>
              <p class="mb-2">{{ comment.commentText }}</p>
              <div *ngIf="comment.productPhotoUrlComments">
                <img [src]="comment.productPhotoUrlComments" alt="Foto del comentario" class="comment-photo-thumbnail">
              </div>
            </div>
          </div>
        </div>
        <ng-template #noComments>
          <div class="alert alert-info">
            No hay comentarios para este producto todavía. ¡Sé el primero en comentar!
          </div>
        </ng-template>
      </div>
    </div>

    <!-- Sección de formulario para agregar un comentario -->
    <div class="row mt-4">
      <div class="col-12">
        <div class="card p-4 shadow-sm">
          <h3 class="mb-3">¡Deja tu comentario!</h3>
          <form (ngSubmit)="submitComment()">
            <div class="form-group mb-3">
              <label for="customerName">Tu nombre</label>
              <input type="text" id="customerName" class="form-control" [(ngModel)]="newComment.customerName" name="customerName" required>
            </div>
            <div class="form-group mb-3">
              <label for="commentText">Tu comentario</label>
              <textarea id="commentText" class="form-control" [(ngModel)]="newComment.commentText" name="commentText" rows="4" required></textarea>
            </div>
            <div class="form-group mb-3">
              <label>Calificación</label>
              <div>
                <i class="fas fa-star"
                   [class.text-warning]="newComment.rating >= 1"
                   [class.text-secondary]="newComment.rating < 1"
                   (click)="setRating(1)"></i>
                <i class="fas fa-star"
                   [class.text-warning]="newComment.rating >= 2"
                   [class.text-secondary]="newComment.rating < 2"
                   (click)="setRating(2)"></i>
                <i class="fas fa-star"
                   [class.text-warning]="newComment.rating >= 3"
                   [class.text-secondary]="newComment.rating < 3"
                   (click)="setRating(3)"></i>
                <i class="fas fa-star"
                   [class.text-warning]="newComment.rating >= 4"
                   [class.text-secondary]="newComment.rating < 4"
                   (click)="setRating(4)"></i>
                <i class="fas fa-star"
                   [class.text-warning]="newComment.rating >= 5"
                   [class.text-secondary]="newComment.rating < 5"
                   (click)="setRating(5)"></i>
              </div>
            </div>
            <!--div class="form-group mb-4">
              <label for="commentPhoto">URL de una foto del producto (opcional)</label>
              <input type="url" id="commentPhoto" class="form-control" [(ngModel)]="newComment.productPhotoUrlComments" name="commentPhoto">
            </div-->
            <button type="submit" class="btn btn-primary">Enviar comentario</button>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>

